export default "__VITE_ASSET__B$C6Jmk0__"